<template>
  <div>
    <span :class="[j_id == item.id ? 'active fl name' : 'fl name']" v-for="item in list" :key="item.id" @click="_setjob(item.id)">{{item.name}}</span>
  </div>
</template>


<script>
import { getJobList } from '@/api/portal';
export default {
  props: {
    id: {
      type: String,
    },
    fn: {
      type: Array,
    },
    jid: {
      type: String,
    },
  },
  data() {
    return {
      list: [],
      j_id: '',
    };
  },
  watch: {
    jid() {
      this.j_id = this.jid;
    },
  },
  methods: {
    //获取工作
    _getjob() {
      getJobList({
        action: 'recruit.job.getJobList',
        type_id: this.id,
      })
        .then(res => {
          this.list = res.data;
          this.$emit('child', res.data.length);
        })
        .catch(err => {});
    },
    _setjob(id) {
      this.j_id = id;
      this.$emit('throw', this.list.filter(item => item.id == id)[0] || {});
    },
  },
  created() {
    this._getjob();
  },
};
</script>


<style scoped>
.name {
  font-size: 16px;
  cursor: pointer;
  margin-left: 24px;
  line-height: 32px;
  display: inline-block;
}
.name:hover {
  border-bottom: 2px solid #ff6a00;
  color: #ff6a00;
}
/* .name:nth-child(n + 2) {
  margin-left: 24px;
} */
.active {
  color: #ff6a00;
}
</style>
